import { vfmPlugin } from 'vue-final-modal';
import DialogBase from '@/components/dialogs/Dialog.vue';
import InvestDialog from '@/components/dialogs/InvestDialog.vue';
import ModalIllustration from '@/components/dialogs/ModalIllustration.vue';

export function setupVueFinalModal(app) {
    app.use(vfmPlugin({
        key: '$vfm',
        componentName: 'VueFinalModal',
        dynamicContainerName: 'ModalsContainer'
    }));
    app.component('DialogBase', DialogBase);
    app.component('InvestDialog', InvestDialog);
    app.component('ModalIllustration', ModalIllustration);
}
